import {
  FccAdAlertStatus,
  FccOperatorRoleType,
} from '@backoffice-frontend/graphql'
import type { AdAlertFeedCardVehicleFragment } from './AdAlertFeedCard.hook'

export const getHandlingOperatorForRole = (
  vehicle: Pick<
    AdAlertFeedCardVehicleFragment,
    'fccHandledByOperator' | 'fccHandledByRs' | 'fccHandledByRao'
  >,
  role: FccOperatorRoleType | undefined,
) => {
  switch (role) {
    case FccOperatorRoleType.RiderSupport:
      return vehicle.fccHandledByRs
    case FccOperatorRoleType.RemoteAssistanceOperator:
      return vehicle.fccHandledByRao
    default:
      return vehicle.fccHandledByOperator
  }
}

/**
 * Name fields of the handling operator for the active role. Kept separate from
 * getHandlingOperatorForRole because the legacy roleless field exposes names
 * only through the fccHandledByOperatorDetails alias.
 */
export const getHandlingOperatorDetailsForRole = (
  vehicle: Pick<
    AdAlertFeedCardVehicleFragment,
    'fccHandledByOperatorDetails' | 'fccHandledByRs' | 'fccHandledByRao'
  >,
  role: FccOperatorRoleType | undefined,
) => {
  switch (role) {
    case FccOperatorRoleType.RiderSupport:
      return vehicle.fccHandledByRs
    case FccOperatorRoleType.RemoteAssistanceOperator:
      return vehicle.fccHandledByRao
    default:
      return vehicle.fccHandledByOperatorDetails
  }
}

export const getActiveAlerts = (
  vehicle: Pick<AdAlertFeedCardVehicleFragment, 'roleScopedAdAlerts'>,
) =>
  vehicle.roleScopedAdAlerts?.alerts.filter(
    alert => alert.status !== FccAdAlertStatus.Closed,
  ) ?? []
